import { Controller } from "@hotwired/stimulus"

// Hides the "Sum" mode option when fewer than 2 compared CAs are selected.
// "Sum of one" is semantically identical to "any of one," so the choice is
// only meaningful when 2+ CAs are on the comparison side.
export default class extends Controller {
  static targets = ["candidate", "sumOption", "sumRadio", "anyRadio"]

  connect() {
    this.update()
  }

  update() {
    const checkedCount = this.candidateTargets.filter((cb) => cb.checked).length
    const canSum = checkedCount >= 2

    this.sumOptionTarget.classList.toggle("hidden", !canSum)
    this.sumRadioTarget.disabled = !canSum

    if (!canSum && this.sumRadioTarget.checked) {
      this.anyRadioTarget.checked = true
    }
  }
}
